module.exports = __webpack_public_path__ + "media/assets/images/post-bg/post-bg-1-5ed76af11fddf2a08e2edd08fbae92af.jpg";